module.exports = {
  PRODUCT_CREATE: 'Product Create',
};
